import React, { Fragment } from 'react'
import styled from 'styled-components'
import { NameHeader } from '../../Kiosk/Kiosk'

const MonoHeader = styled.div`
    position: relative;
    background-image: url(${_ => _.backgroundImage});
    background-position: center;
    background-size: cover;
    height: 310px;

    @media screen and (max-width: 1023px) {
        height: 100px;
    }
`

const Logo = styled.img`
    position: absolute;
    left: 10%;
    top: 0px;
    height: 100%;

    @media screen and (max-width: 1023px) {
        height: 100px;
    }
`

const monoHeader = ({
    concept,
    menu,
    kioskName,
    monoKioskPicture,
    useCommercialName,
}) => (
    <Fragment>
        <MonoHeader
            backgroundImage={
                menu
                    ? `img/concept/${concept}/menu/${monoKioskPicture ||
                          menu}/mono-header.png?_=9edb01b`
                    : `img/concept/${concept}/kiosk/${monoKioskPicture ||
                          kioskName}/mono-header.png?_=9edb01b`
            }
        >
            {!useCommercialName && (
                <Logo
                    src={
                        menu
                            ? `img/concept/${concept}/menu/${monoKioskPicture ||
                                  menu}/mono-logo.png?_=9edb01b`
                            : `img/concept/${concept}/kiosk/${monoKioskPicture ||
                                  kioskName}/mono-logo.png?_=9edb01b`
                    }
                />
            )}
        </MonoHeader>
        {useCommercialName && <NameHeader mono>{kioskName}</NameHeader>}
    </Fragment>
)

export default monoHeader
